package kangaroorewards.appsdk.core.utils

import kangaroorewards.appsdk.core.network.base.Endpoint

object Configuration {

    const val PROXY_BASE_URL: String = "https://us-central1-kangaroo-rewards-app.cloudfunctions.net/apiproxy/"

    fun getUploadImageEndpoint(module: Int?): Endpoint {
        return when (module) {
            0 -> {
                Endpoint(path = "users/me/images")
            }
            1 -> {
                Endpoint(path = "attachments")
            }
            2 -> {
                Endpoint(path = "offers/images")
            }
            3 -> {
                Endpoint(path = "rewards/images")
            }
            4 -> {
                Endpoint(path = "attachments")
            }
            else -> {
                Endpoint(path = "users/me/images")
            }
        }
    }
}